export const formHandlers = (getAnswers, otherValues, setState, changeFormQuestionAnswers) => ({
  handleCheckboxChange(question, value) {
    const current = getAnswers(question).slice();
    const idx = current.indexOf(value);
    if (idx === -1) current.push(value);
    else current.splice(idx, 1);
    changeFormQuestionAnswers(question.id, current);
  },

  handleOtherCheckboxChange(question) {
    const otherValue = otherValues[question.id] || "";
    const current = getAnswers(question).slice();
    const otherChecked = !!otherValue && current.includes(otherValue);

    if (otherChecked) {
      setState((prev) => ({ ...prev, otherValues: { ...prev.otherValues, [question.id]: "" } }));
      changeFormQuestionAnswers(
        question.id,
        current.filter((a) => a !== otherValue),
      );
    } else {
      setState((prev) => ({ ...prev, otherValues: { ...prev.otherValues, [question.id]: " " } }));
    }
  },

  handleOtherCheckboxInput(question, value) {
    const current = getAnswers(question).slice();
    const prevOther = otherValues[question.id] || "";
    const next = current.filter((a) => a !== prevOther);
    if (value) next.push(value);
    setState((prev) => ({ ...prev, otherValues: { ...prev.otherValues, [question.id]: value } }));
    changeFormQuestionAnswers(question.id, next);
  },

  handleRadioChange(question, value) {
    setState((prev) => ({
      ...prev,
      selectedOther: { ...prev.selectedOther, [question.id]: false },
      otherValues: { ...prev.otherValues, [question.id]: "" },
    }));
    changeFormQuestionAnswers(question.id, [value]);
  },

  handleOtherRadioSelect(question) {
    setState((prev) => ({
      ...prev,
      selectedOther: { ...prev.selectedOther, [question.id]: true },
    }));
    const otherVal = otherValues[question.id] || "";
    changeFormQuestionAnswers(question.id, otherVal ? [otherVal] : []);
  },

  handleOtherRadioInput(question, value) {
    setState((prev) => ({ ...prev, otherValues: { ...prev.otherValues, [question.id]: value } }));
    changeFormQuestionAnswers(question.id, value ? [value] : []);
  },

  handleValueChange(question, value) {
    changeFormQuestionAnswers(question.id, [value]);
  },

  handleDateChange(question, date) {
    changeFormQuestionAnswers(question.id, date ? [date.valueOf().toString()] : []);
  },
});
